import CustomerView from '@/pages/setting/customer/CustomerView';
import ProductGroupView from '@/pages/setting/productGroup/ProductGroupView';
import ProductView from '@/pages/setting/product/ProductView';
import OfferView from '@/pages/setting/offers/OfferView';
import TermsAndConditionsView from '@/pages/setting/terms-and-conditions/TermsAndConditionsView';
import ServicesView from '@/pages/setting/services/ServicesView';
import AlternateProductView from '@/pages/setting/alternate-product/AlternateProductView';
import AccessPrivilegeView from '@/pages/setting/access-privilege/AccessPrivilegeView';
import ManageAccess from '@/pages/setting/access-privilege/ManageAccess';
import ManageProductFile from '@/pages/setting/manage-product-file/ManageProductFile';

const settingRoutes = [
  { path: 'customer', element: CustomerView },
  { path: 'product-group', element: ProductGroupView },
  { path: 'product', element: ProductView },
  { path: 'offers', element: OfferView },
  { path: 'termsandconditions', element: TermsAndConditionsView },
  { path: 'service', element: ServicesView },
  { path: 'alternate-product', element: AlternateProductView },
  { path: 'user-access', element: AccessPrivilegeView },
  { path: 'user-access/access/:role/:id', element: ManageAccess },
  { path: 'manage-product-file', element: ManageProductFile },
];

export default settingRoutes;
